// Moving between screens with real paths (/orders, /order/2, /vendor-po/TG-S0001), not #/ fragments. CloudFront
// sends any path that isn't a file to the app's page (infra/lib/app.ts, a CloudFront Function); the app draws the
// screen for location.pathname, and moves with the browser's history, so Back, Forward, reload and a shared link
// all work. Links are plain <a href="/…">; a click on one is caught and becomes a history step.

export const RELOAD = "tare:reload";

/** Go to a path in the app (a history step; the screen is drawn by the router). */
export function navigate(path: string): void {
  if (path === location.pathname + location.search) return reload();
  history.pushState(null, "", path);
  window.dispatchEvent(new Event(RELOAD));
}

/** Draw the current screen again (after an act that changes what it shows). */
export function reload(): void {
  window.dispatchEvent(new Event(RELOAD));
}

/**
 * A link from before real paths ("#/order/2", "#/orders?status=ALL") as a path ("/order/2", "/orders?status=ALL"),
 * so bookmarks and links in earlier emails still land; null when there's no such fragment.
 */
export function fromHash(hash: string): string | null {
  const m = /^#\/(.*)$/.exec(hash);
  return m ? `/${m[1]}` : null;
}

/** Whether a click on this link should stay in the app: same site, a plain left click, not a new tab or a download. */
export function inApp(a: { href: string; target: string; hasAttribute(n: string): boolean }, e: { button: number; metaKey: boolean; ctrlKey: boolean; shiftKey: boolean; altKey: boolean }, origin: string,
  here?: { pathname: string; search: string }): boolean {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
  if ((a.target && a.target !== "_self") || a.hasAttribute("download")) return false;
  const url = new URL(a.href);
  // A link to a spot on this same screen (#qb) is the browser's: it scrolls there rather than drawing the screen again.
  if (url.hash && here && url.pathname === here.pathname && url.search === here.search) return false;
  return url.origin === origin && !url.pathname.startsWith("/api/");
}
